import React from 'react';
import { useUnistyles } from 'react-native-unistyles';

const ButtonBlock = ({ block, isSelected, onSelect }) => {
    const { theme: { colors } } = useUnistyles();
    const { content, styles: blockStyles } = block;

    const padding = `${blockStyles.paddingTop ?? 10}px ${blockStyles.paddingRight ?? 20}px ${blockStyles.paddingBottom ?? 10}px ${blockStyles.paddingLeft ?? 20}px`;

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
            style={{
                padding,
                backgroundColor: blockStyles.backgroundColor || 'transparent',
                textAlign: content.align || blockStyles.textAlign || 'center',
                outline: isSelected ? `2px solid ${colors.primary}` : '2px solid transparent',
                outlineOffset: '-2px',
                cursor: 'pointer',
            }}
        >
            <a
                href={content.href || '#'}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.preventDefault()}
                style={{
                    display: content.fullWidth ? 'block' : 'inline-block',
                    padding: '12px 24px',
                    backgroundColor: content.backgroundColor || '#1460a5',
                    color: content.textColor || '#ffffff',
                    textDecoration: 'none',
                    borderRadius: `${content.borderRadius ?? 4}px`,
                    fontSize: 14,
                    fontWeight: 'bold',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    textAlign: 'center',
                }}
            >
                {content.text || 'Click Here'}
            </a>
        </div>
    );
};

export default ButtonBlock;
